import { useEffect, useState } from 'react'
import useTicketNotes from '../useTicketNotes'
import { socketManager } from '../../context/Socket/SocketContext'

const useTicketHistory = (ticket, contact) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const { getTicketHistory } = useTicketNotes();

  const fetchHistory = async () => {
    if (!ticket?.id || !contact?.id) return;

    setLoading(true);
    try {
      const data = await getTicketHistory(ticket.id, contact.id);
      setHistory(data);
    } catch (error) {
      console.error('Erro ao buscar histórico do ticket:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, [ticket?.id, contact?.id]);

  // Atualizar histórico quando o ticket mudar via socket
  useEffect(() => {
    if (!ticket?.id) return;

    const companyId = localStorage.getItem("companyId");
    const socket = socketManager.GetSocket(companyId);

    const onTicketUpdate = (data) => {
      if (data.action === "update" && data.ticket?.id === ticket.id) {
        // Aguardar um pouco antes de atualizar para garantir que a nota foi criada
        setTimeout(() => {
          fetchHistory();
        }, 1000);
      }
    };

    socket.on(`company-${companyId}-ticket`, onTicketUpdate);

    const onAttendantChange = () => {
      setTimeout(() => {
        fetchHistory();
      }, 500);
    };

    socket.on("ticketAttendantRemoved", onAttendantChange);
    socket.on("ticketAttendantAdded", onAttendantChange);

    return () => {
      socket.off(`company-${companyId}-ticket`, onTicketUpdate);
      socket.off("ticketAttendantRemoved", onAttendantChange);
      socket.off("ticketAttendantAdded", onAttendantChange);
    };
  }, [ticket?.id]);

  return {
    history,
    loading,
    refreshHistory: fetchHistory
  };
};

export default useTicketHistory;
